import { useSelector, shallowEqual } from 'react-redux';
import type { IRootState } from '../store';

export function useShallowSelector<T>(selector: (state: IRootState) => T): T {
  return useSelector(selector, shallowEqual);
}

export { useDispatch } from 'react-redux';
